import { getApiConfig } from './../../../utilities';
import customEvent from "../../../utilities/customEvent";
const {get, post} = getApiConfig('Installation/');

const actionTypePrefix = "installation/new-installation-group";
export const newInstallationGroupActionTypes = {
  LOAD: `${actionTypePrefix}/load`,
  ADD: `${actionTypePrefix}/add`,
  CLEAR: `${actionTypePrefix}/clear`,
  SAVE_ITEM: `${actionTypePrefix}/save-item`
}

export const addNewInstallationGroup = (name, description, image) => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      dispatch({
        type: newInstallationGroupActionTypes.ADD,
        payload: {
          name,
          description,
          image
        }
      });
      resolve();
      document.dispatchEvent(customEvent("newInstallationGroupAdded"));
    }).catch(console.error);
  }
}

export const saveInstallationItem = (data) => {
  return (dispatch) => {
    dispatch({
      type: newInstallationGroupActionTypes.SAVE_ITEM,
      payload: data
    });
    document.dispatchEvent(customEvent('installation-item-saved'));
  }
}

export const loadNewinstallationGroups = () => {
  return (dispatch, getState) => {
    return new Promise(resolve => {

    }).catch(console.error);
  }
}
